import { useEnum } from "@/api/services/global/enum";
import { Tag } from "@/components/elements/Tag";
import { EMPTY_STR } from "@/constants/string";
import { background, black, state } from "@/theme/colors";
import { ERSOContractStatus } from "@/types/enum";
import { findLabelByValue } from "@/utils/object";
import { FC, useMemo } from "react";

export type TRsoStatusTagProps = {
  status: string;
};

export const RsoStatusTag: FC<TRsoStatusTagProps> = ({ status }) => {
  const { data: contractStatusOptions } = useEnum("ERSOContractStatus");

  const colorTagProps = useMemo(() => {
    if (status === ERSOContractStatus.TRIAL) {
      return { color: state.warning_2, pointColor: state.warning_1 };
    }
    if (status === ERSOContractStatus.DURING_CONTRACT) {
      return { color: state.success_2, pointColor: state.success_1 };
    }
    if (status === ERSOContractStatus.CANCELED_CONTRACT) {
      return { color: state.error_2, pointColor: state.error_1 };
    }
    if (status === ERSOContractStatus.TRIAL_CANCELLED) {
      return { color: background.disable, pointColor: black[80] };
    }

    return { color: background.disable };
  }, [status]);

  if (status === ERSOContractStatus.DELETED_CONTRACT) {
    return null;
  }

  return <Tag enablePoint variant="bold" title={findLabelByValue(contractStatusOptions, status) || EMPTY_STR.TEXT} {...colorTagProps} />;
};
